@App = {
  Clubs: {},
  Components: {},
  Pages: {},
  Ui: {}
}

export App = @App
